import { z } from 'zod';
export const responseProposalSchema = z.object({
  proposalId: z.uuid(),
  caseId: z.uuid(),
  caseVersion: z.string().min(1).max(160),
  postId: z.uuid(),
  commentId: z.uuid(),
  commentVersion: z.string().min(1).max(160),
  response: z.string().min(10).max(4000),
  reason: z.string().min(10).max(2000),
  answeredAt: z.iso.datetime(),
  proposedAt: z.iso.datetime(),
});
export type ResponseProposalPayload = z.infer<typeof responseProposalSchema>;
